/**
 * Tool formatting utilities
 */

/**
 * Get display name for a tool execution
 */
export function getToolDisplayName(toolName: string, input: any): string {
  switch (toolName) {
    case 'write_file':
      return input?.path ? `Write: ${input.path}` : 'Write file';
    case 'view_file':
      return input?.path ? `Read: ${input.path}` : 'Read file';
    case 'str_replace':
      return input?.path ? `Edit: ${input.path}` : 'Edit file';
    case 'delete_file':
      return input?.path ? `Delete: ${input.path}` : 'Delete file';
    case 'list_files':
      return input?.path ? `List: ${input.path}` : 'List files';
    case 'shell_exec':
      return input?.command ? `$ ${input.command}` : 'Shell command';
    case 'search':
      return input?.query ? `Search: ${input.query}` : 'Search';
    case 'web_search':
      return input?.query ? `Web search: ${input.query}` : 'Web search';
    case 'todos':
      return 'Task management';
    case 'error_reports_list':
      return 'List error reports';
    case 'error_reports_update':
      return 'Update error report';
    default:
      return toolName.replace(/_/g, ' ');
  }
}

/**
 * Check if a tool should be hidden from display
 */
export function shouldHideTool(toolName: string, toolInput: any): boolean {
  // Hide todos list actions - they're internal state checks
  if (toolName === 'todos') {
    const action = toolInput?.action;
    return action === 'list' || action === 'list_incomplete';
  }

  return false;
}
